import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getWebview } from '@cian/webview/webview';

import { selectMyHomeIdMigration } from '../../selectors/myHomeMigrationBanner';
import { MyHomeMigrationBanner } from '../../components/MyHomeMigrationBanner';
import { useTracking } from './useTracking';
import { setQueryParams, updateUrl } from '../../actions/page';
import { TThunkDispatch } from '../../types/redux';

export const MyHomeMigrationBannerContainer: React.FC = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const myHomeIdMigration = useSelector(selectMyHomeIdMigration);
  const { trackCustomNewpage } = useTracking();

  const onClickHandler = React.useCallback(() => {
    /**
     * Без проверки на isWebview, потому что этот баннер доступен только внутри пуша,
     * который открывается только в вебвью
     */
    const webview = getWebview();
    webview.sendAction({
      action: 'open-deeplink',
      payload: {
        url: 'https://www.cian.ru/my-home/main',
      },
    });
  }, []);

  React.useEffect(() => {
    if (myHomeIdMigration) {
      // oxlint-disable-next-line typescript/no-non-null-assertion
      dispatch(setQueryParams({ myHome: myHomeIdMigration! }));
      dispatch(updateUrl());
      trackCustomNewpage();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
  }, []);

  if (!myHomeIdMigration) {
    return null;
  }

  return <MyHomeMigrationBanner onClick={onClickHandler} />;
};

MyHomeMigrationBannerContainer.displayName = 'MyHomeMigrationBannerContainer';
